import { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectUser } from '../../store/user/user.selector';
import useTransactionsReady from '../../hooks/useTransactionsReady';

// styles
import {
  SalesPageContainer
} from './SalesPage.styles.js';

// components
import HeaderWidget from '../../components/widgets/header-widget/HeaderWidget.js';
import PrimaryBtn from '../../components/btns/primary-btn/PrimaryBtn.js';
import SubNavHeader from '../../components/sub-nav-header/SubNavHeader.js';
import Title from '../../components/widgets/components/title/Title.js';
import CreateSaleModal from './components/sales-tracker/components/create-sale-modal/CreateSaleModal.js';
import AddInventoryModal from './components/sales-inventory/components/add-inventory-modal/AddInventoryModal.js';

export default function SalesPage() {
  const navigate = useNavigate();
  const user = useSelector(selectUser);
  const ready = useTransactionsReady(user?.uid);
  const [showSaleModal, setShowSaleModal] = useState(false);
  const [showInventoryModal, setShowInventoryModal] = useState(false);

  const handleSaleCreateSuccess = () => {
    setShowSaleModal(false);
    navigate('/transactions/tracker');
  };

  return (
    <SalesPageContainer>
      <HeaderWidget fullWidth={true}>
        <Title text="TRANSACTIONS" />
        <>
          <SubNavHeader navItems={[
            { title: "Dashboard", path: "/transactions/dashboard" },
            { title: "Queue", path: "/transactions/queue" },
            { title: "Tracker", path: "/transactions/tracker" },
            { title: "Inventory", path: "/transactions/inventory" },
          ]} />
          <PrimaryBtn title="+ NEW INVENTORY" onClick={() => setShowInventoryModal(true)} />
          <PrimaryBtn title="+ NEW SALE" onClick={() => setShowSaleModal(true)} />
        </>
      </HeaderWidget>

      {ready ? <Outlet /> : null}

      {showSaleModal && (
        <CreateSaleModal
          isOpen={showSaleModal}
          onClose={() => setShowSaleModal(false)}
          onSuccess={handleSaleCreateSuccess}
        />
      )}

      <AddInventoryModal
        isOpen={showInventoryModal}
        onClose={() => setShowInventoryModal(false)}
      />
    </SalesPageContainer>
  )
}
